import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { Container } from 'tmt-ui-kit';
import styled from 'styled-components';
import { connect } from 'react-redux';

import headTags from '~/head-tags';

import HeadTag from '~/components/Head/HeadTag';
import HistorySection from '~/components/Row/HistorySection';
import Filter from '~/components/Search/Filter';
import SearchBox from '~/components/Search/SearchBox';
import MobileFilter from '~/components/Search/MobileFilter';
import InfiniteScrollSearch from '~/components/Search/InfiniteScrollSearch';
import NotFound from '~/components/NotFound/NotFound';
// import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';

import config from '~/config';
import { actions as searchActions } from '~/redux/reducers/search';
import { actions as tripActions } from '~/redux/reducers/trip';
import { getHeadTagKey, getTitleTag, getDescriptionTag, getH1 } from '~/utils/helpers';
import { parseQueryToFilter } from '~/utils/search';

const Breadcrumbs = dynamic(
  () => import(/* webpackChunkName: "Breadcrumbs.Breadcrumbs.components" */'../../components/Breadcrumbs/Breadcrumbs'),
  { loading: () => null }
);

const Title = styled.h1`
  @media (max-width: 700px) {
    margin: 10px 0;  
  }
`;

const MainContainer = styled.div`
  padding-bottom: 20px;
`;

const showAllTripCities = ['Chiang Rai', 'Hat Yai', 'Nakorn Ratchasima', 'Surat Thani', 'Krabi'];

const enhance = connect(
  state => ({
    topics: state.search.data,
    history: state.search.history,
    searching: state.search.searching,
    appending: state.search.appending,
    filtering: state.search.filtering,
    isEnd: state.search.isEnd,
    exchangeRates: state.info.exchangeRates,
    currency: state.session.data.currency,
    filterData: state.search.filter,
    isShowFilter: state.search.isShowFilter,
    userConfig: state.info.userConfig,
    isOpenMobileFilter: state.search.isOpenMobileFilter,
  }),
  {
    search: searchActions.search,
    getHistory: searchActions.getHistory,
    logClickCard: tripActions.logClickCard,
    logImpressCard: tripActions.logImpressCard,
    logImpressTopic: tripActions.logImpressTopic,
    logClickSeeMore: tripActions.logClickSeeMore,
    logScrollEnd: tripActions.logScrollEnd,
    logOpenFilter: searchActions.logOpenFilter,
    logClearFullTextSearch: searchActions.logClearFullTextSearch,
    logSubmitFullTextSearch: searchActions.logSubmitFullTextSearch,
    updateFilter: searchActions.updateFilter,
    clearFilter: searchActions.clearFilter,
    openMobileFilter: searchActions.openMobileFilter,
  }
);

class Search extends Component {
  static propTypes = {
    url: PropTypes.object,
    filterData: PropTypes.object,
    history: PropTypes.object,
    search: PropTypes.func,
    getHistory: PropTypes.func,
    topics: PropTypes.array,
  };

  static async getInitialProps({ store, query, req, res }) {
    try {
      if (
        query.affid === 'tg'
        && query.utm_campaign === 'tg-lifestyle'
        && query.utm_medium === 'referral'
        && query.utm_source === 'tg-lifestyle'
      ) {
        return res.redirect('/to/Bangkok?affid=tg&utm_campaign=tg-lifestyle&utm_medium=referral&utm_source=tg-lifestyle');
      }
      const search = {
        ...query,
        skip: 0,
      };
      const filter = parseQueryToFilter(query);
      store.dispatch(searchActions.updateFilter(filter));
      const data = await store.dispatch(searchActions.search(search, false));
      if (!data || !data.data || data.data.length === 0) {
        let qstr = '';
        if (req && req.url && req.url.match(/\?.+/)) {
          qstr = req.url.match(/\?.+/);
        }
        if (res && res.writeHead && query.city) {
          res.writeHead(301, { Location: `/to/${query.city}${qstr}` });
          res.end();
        }
      }
    } catch (error) {
      if (res) res.statusCode = 404;
    }
    return {};
  }

  componentDidMount() {
    this.props.getHistory();
  }

  search = (skip, append = false, filter = false) => {
    const { query } = this.props.url;
    this.props.search(
      {
        ...query,
        ...this.props.filterData,
        skip,
      },
      append,
      filter,
    );
  };

  render() {
    const { topics, url, history } = this.props;
    const query = {
      city: url.query.city,
      type: url.query.type,
    };
    const location = query.city;
    const tagType = getHeadTagKey(query.type);
    const title = getTitleTag(tagType, location, headTags);
    const description = getDescriptionTag(tagType, location, headTags);
    const h1 = getH1(tagType, location, headTags);
    const keywords = headTags
      && headTags[location]
      && headTags[location].keywords
      ? headTags[location].keywords
      : location;
    return (
      <div>
        <HeadTag
          title={title || `Local day tours in ${location}`}
          description={description}
          keywords={keywords}
          image={`${config.baseURL.en}/static/images/Search/mobile-background.jpg`}
        />
        <MainContainer>
          <Container.InnerContainer>
            {h1 && <Title className="title">{h1}</Title>}
            <Breadcrumbs
              type="Search"
              data={{
                h1, city: query.city
              }}
            />
            {history && Array.isArray(history.trip_ids) && history.trip_ids.length > 0 && (
              <div key="history-data">
                <HistorySection
                  {...this.props}
                  objects={history.trip_ids}
                  fullPath={url.query.fullPath}
                />
              </div>
            )}
            {!showAllTripCities.includes(location) && (
              <div className="tmt-mobile-hide">
                {query.type !== 'local-experts' && (
                  <Filter {...this.props} query={query} />
                )}
                <SearchBox {...this.props} />
              </div>
            )}
            {(!topics || topics.length < 1) && <NotFound isSearch />}
            <InfiniteScrollSearch
              {...this.props}
              search={this.search}
              query={query}
              loadedDataCount={topics.length}
              focus={showAllTripCities.includes(location) ? true : url.query.focus}
              fullPath={url.query.fullPath}
              h1={h1}
            />
          </Container.InnerContainer>
        </MainContainer>
        {!showAllTripCities.includes(location) && query.type !== 'local-experts' && (
          <MobileFilter
            {...this.props}
            query={query}
            filterData={this.props.filterData}
          />
        )}
      </div>
    );
  }
}

export default enhance(Search);
